import React from 'react';
import { Popover } from 'antd';
import { inject, observer } from 'mobx-react';
import { Icon, Avatar } from '@/components';
import { RootStore } from '@/models';
import { ChatMessage } from '@/types/meeting';
import NickName from '@/components/NickName';
import styles from './popover.less';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'chat' | 'meeting'>> {
  chat?: RootStore['chat'];
  meeting?: RootStore['meeting'];
  children: React.ReactNode;
  popoverVisible: boolean;
  onPopoverVisibleChange: (visible: boolean) => void;
  onClick: (e: any) => void;
}

let closeTimer = 0;
let unReadMsgTimer = 0;
const UnReadChatPopover: React.FC<Props> = inject(({ store }) => {
  return {
    chat: store.chat,
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { chat, meeting, popoverVisible, children, onPopoverVisibleChange, onClick } = props;
    const [unReadMsg, setUnReadMsg] = React.useState<ChatMessage | null>(null);

    React.useEffect(() => {
      if (chat?.unReadMsg) {
        onPopoverVisibleChange(true);
        clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          onPopoverVisibleChange(false);
        }, 5000);
        setUnReadMsg(chat?.unReadMsg);
        clearTimeout(unReadMsgTimer);
      } else {
        unReadMsgTimer = window.setTimeout(() => {
          setUnReadMsg(null);
        }, 500);
      }
    }, [chat?.unReadMsg]);

    const unreadNickName = React.useMemo(() => {
      if (unReadMsg) {
        return (
          unReadMsg?.fromNick || meeting?.getMemberInfoByChatId(unReadMsg?.from)?.memberName || ''
        );
      }
      return '';
    }, [chat, meeting, unReadMsg]);

    return (
      <Popover
        placement="top"
        builtinPlacements={
          isMobile
            ? {
                top: {
                  points: ['tc', 'bl'],
                  offset: [28, -168],
                  overflow: {
                    adjustX: 10,
                  },
                },
              }
            : undefined
        }
        overlayClassName={styles['msg-popover']}
        content={
          <div className={styles['chat-popover-box']} onClick={(e) => onClick(e)}>
            <div className={styles['chat-popover-left']}>
              <Avatar
                size={isMobile ? 44 : 36}
                type="cover"
                yxuid={unReadMsg?.custom?.yxUid}
                name={unReadMsg?.fromNick || ''}
              />
            </div>
            <div className={styles['chat-popover-right']}>
              <span
                className={styles['msg-popover-close']}
                onClick={(e) => {
                  onPopoverVisibleChange(false);
                  e.stopPropagation();
                }}
              >
                <Icon
                  name="icon-close_nor"
                  className={styles['msg-popover-close-icon']}
                  style={{ color: '#2A2D32' }}
                />
              </span>
              <div className={styles['msg-header-name']}>
                <NickName yxUid={unReadMsg?.custom?.yxUid} defaultName={unreadNickName} />
              </div>
              <div className={styles['msg-header-text']}>{unReadMsg?.text}</div>
            </div>
          </div>
        }
        visible={popoverVisible}
      >
        {children}
      </Popover>
    );
  })
);

export default UnReadChatPopover;
